import { useState } from "react";
import { Box, Typography, IconButton, Avatar, Menu, Divider, MenuItem, ListItemIcon } from "@mui/material"
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import LogoutDialog from "../LogoutDialog/LogoutDialog";

interface HeaderProps {
    title: string;
    currentAdminName: string;
}

export default function Header({ title, currentAdminName }: HeaderProps) {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [isLogoutDialogOpen, setIsLogoutDialogOpen] = useState<boolean>(false);

    const open = Boolean(anchorEl);

    const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        handleClose();
        setIsLogoutDialogOpen(true);
    };


    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    mb: 4,
                    flexWrap: 'wrap',
                    flexFlow: 'row'
                }}
            >
                <Typography
                    variant="h4"
                    fontWeight={600}
                >
                    {title}
                </Typography>

                <Typography variant="body2">
                    Welcome back, {currentAdminName}
                    <IconButton onClick={handleOpen} size="small" sx={{ ml: 1 }}>
                        <Avatar sx={{
                            width: 40,
                            height: 40,
                            backgroundColor: '#fff',
                            borderStyle: 'solid',
                            borderColor: '#E3E3E3'
                        }}
                        >
                            <PersonOutlineOutlinedIcon
                                sx={{
                                    color: '#CDCDCD'
                                }}
                            />
                        </Avatar>
                    </IconButton>


                    <Menu
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        onClick={handleClose}
                        PaperProps={{
                            sx: {
                                p: 1.5,
                                width: 200,
                            },
                        }}
                        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                    >
                        <Box display="flex" alignItems="center" gap={1} mb={1}>
                            <Avatar sx={{
                                width: 40,
                                height: 40,
                                backgroundColor: '#fff',
                                borderStyle: 'solid',
                                borderColor: '#E3E3E3'
                            }}
                            >
                                <PersonOutlineOutlinedIcon
                                    sx={{
                                        color: '#CDCDCD'
                                    }}
                                />
                            </Avatar>
                            <Box>
                                <Typography variant="subtitle1" fontWeight={600}>
                                    {currentAdminName}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    Admin
                                </Typography>
                            </Box>
                        </Box>
                        <Divider />

                        <MenuItem onClick={handleLogout}>
                            <ListItemIcon>
                                <LogoutIcon fontSize="small" />
                            </ListItemIcon>
                            Logout
                        </MenuItem>
                    </Menu>
                </Typography>
            </Box>

            {/* Logout Dialog */}
            <LogoutDialog open={isLogoutDialogOpen} setOpen={setIsLogoutDialogOpen} />
        </>
    )

}